import WaitCharge from "@/views/charge/waitcharge/WaitCharge"
export const waitcharge = {
    path: '/waitcharge',
    name: 'WaitCharge',
    component: WaitCharge
  }


// WEBPACK FOOTER //
// ./src/router/index/charge/waitcharge/index.js